import React from 'react';
import { CheckIcon } from 'lucide-react';
import { packages } from '../data/packages';
import { StartCta } from './CtaButton';
export function Pricing() {
  return <section className="bg-brand-light" aria-labelledby="pricing-heading" data-id="element-98" data-mp="2aphrx7khw7y9">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20 lg:py-24" data-id="element-99" data-mp="2ohxp3rqptbr9">
        <div className="max-w-2xl" data-id="element-100" data-mp="2jkxj1gtv8905">
          <h2 id="pricing-heading" className="font-display text-3xl font-extrabold leading-tight tracking-tight sm:text-4xl" data-id="element-101" data-mp="2jlyu3lavsvhv">
            Two ways to launch
          </h2>
          <p className="mt-4 text-base leading-relaxed text-brand-gray" data-id="element-102" data-mp="1rusyni63vlyx">
            Same 72-hour build, same Slack-and-AI changes. Co-Pilot adds the visibility, phones, and
            hosting work on top.
          </p>
        </div>

        <div className="mt-12 grid items-stretch gap-6 lg:grid-cols-2 lg:gap-8" data-id="element-103" data-mp="3h6ldvxaoaj9k">
          {packages.map(pkg => {
          const featured = pkg.featured;
          return <article key={pkg.id} className={`relative flex flex-col bg-brand-white ${featured ? 'border-2 border-brand-red shadow-[0_0_0_6px_rgba(188,33,39,0.12)]' : 'border border-brand-black/10'}`} data-id="element-104" data-mp="3vzp37be3ny5u">
                {pkg.badge ? <p className="bg-brand-red px-6 py-2.5 text-center font-display text-[11px] font-bold uppercase tracking-[0.18em] text-brand-white sm:text-xs" data-id="element-105" data-mp="ep8ytea5et0a">
                    {pkg.badge}
                  </p> : <p className="border-b border-brand-light px-6 py-2.5 text-center font-display text-[11px] font-bold uppercase tracking-[0.18em] text-brand-gray sm:text-xs" data-id="element-106" data-mp="3n6lkooolkv4c">
                    Get online
                  </p>}

                <div className="flex flex-1 flex-col p-7 sm:p-9" data-id="element-107" data-mp="2uhy3b46yypw2">
                  <h3 className="font-display text-2xl font-extrabold uppercase tracking-[0.12em]" data-id="element-108" data-mp="2zgr88886x8km">
                    {pkg.name}
                  </h3>

                  <p className="mt-5 flex items-baseline gap-2" data-id="element-109" data-mp="2rei8kaa1i9o0">
                    <span className={`font-display text-5xl font-extrabold leading-none tracking-tight sm:text-6xl ${featured ? 'text-brand-red' : 'text-brand-black'}`} data-id="element-110" data-mp="2mh06n3ufwupi">
                      {pkg.monthly}
                    </span>
                    <span className="text-sm font-semibold text-brand-gray" data-id="element-111" data-mp="28k3aqnzgsn1r">/month</span>
                  </p>

                  <dl className="mt-7 border-y border-brand-light py-5 text-sm" data-id="element-112" data-mp="23la7dodw6cfb">
                    <div className="flex items-baseline justify-between gap-4" data-id="element-113" data-mp="2ihhmwbecupo9">
                      <dt className="text-brand-gray" data-id="element-114" data-mp="2dfil35y9k0tf">White Glove Onboarding</dt>
                      <dd className="flex items-baseline gap-2 text-right font-semibold" data-id="element-115" data-mp="3tuaf1nb25g4u">
                        <span className="text-brand-gray line-through" data-id="element-116" data-mp="3ox1slaivmpxs">
                          {pkg.onboardingStandard}
                        </span>
                        <span className={featured ? 'text-brand-red' : 'text-brand-black'} data-id="element-117" data-mp="cqbvt2wbe87">
                          {pkg.onboardingOffer}
                        </span>
                      </dd>
                    </div>
                    <div className="mt-3.5 flex items-baseline justify-between gap-4" data-id="element-118" data-mp="3rgez57uf938v">
                      <dt className="font-bold text-brand-black" data-id="element-119" data-mp="j0v9eisym2yk">Total due to start</dt>
                      <dd className="font-display text-lg font-extrabold" data-id="element-120" data-mp="j37p0pb8w18g">
                        {pkg.totalDueToStart}
                      </dd>
                    </div>
                    <div className="mt-2 flex items-baseline justify-between gap-4" data-id="element-121" data-mp="a81r0ci7ungh">
                      <dt className="text-brand-gray" data-id="element-122" data-mp="e8u1f92tqyec">Then</dt>
                      <dd className="font-semibold text-brand-black" data-id="element-123" data-mp="11zzghm0xxmnl">{pkg.monthly}/mo</dd>
                    </div>
                  </dl>

                  <p className="mt-6 text-xs font-bold uppercase tracking-[0.15em] text-brand-gray" data-id="element-124" data-mp="16r93sfz0odwb">
                    {pkg.featuresHeading}
                  </p>
                  <ul className="mt-4 space-y-3 text-sm leading-relaxed" data-id="element-125" data-mp="3a7w7pzhi2ifr">
                    {pkg.features.map(feature => <li key={feature} className="flex gap-3" data-id="element-126" data-mp="35a43c5zo53uo">
                        <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-brand-red" aria-hidden="true" data-id="element-127" data-mp="3180ttmwk89c1" />
                        <span data-id="element-128" data-mp="3syx3kenbpxv3">{feature}</span>
                      </li>)}
                  </ul>

                  <div className="mt-auto pt-8" data-id="element-129" data-mp="3o7otrhi30ahe">
                    <StartCta className="w-full" data-id="element-130" data-mp="3o6drjm4abase" />
                  </div>
                </div>
              </article>;
        })}
        </div>

        <p className="mx-auto mt-8 max-w-3xl text-center text-sm leading-relaxed text-brand-gray" data-id="element-131" data-mp="kjn2n9v66yow">
          Starting Pilot costs $1,114. Starting Co-Pilot costs $1,235 —{' '}
          <span className="font-semibold text-brand-black" data-id="element-132" data-mp="1yf51oerc2o0l">
            just $121 more to start, for a lot more package.
          </span>
        </p>
      </div>
    </section>;
}